import { z } from 'zod';
import { BaseResponseSchema, } from './primitives.js';
/** Query for DELETE /tenant/upload/:filename */
export const UploadDeleteQuerySchema = z.object({
    folder: z.string().optional(),
    subFolder: z.string().optional(),
});
export const LinkFilesRequestSchema = z.object({
    objectKeys: z.array(z.string().min(1)).min(1),
    entityType: z.string().min(1),
    entityId: z.union([z.string(), z.number()]),
    fileCategory: z.string().optional(),
});
export const LinkFilesResponseSchema = BaseResponseSchema.extend({
    message: z.string(),
    data: z.object({
        linkedCount: z.number().int().min(0),
    }),
});
export const DeleteOrphanedFilesRequestSchema = z.object({
    objectKeys: z.array(z.string().min(1)).min(1),
});
export const DeleteOrphanedFilesResponseSchema = BaseResponseSchema.extend({
    message: z.string(),
    data: z.object({
        deletedCount: z.number().int().min(0),
    }),
});
//# sourceMappingURL=tenant-upload.schemas.js.map